import {useCallback, useState} from "react";
import {getProducts} from "../api/api";
import {API_URL} from "../constants/constants";
import logo from "../assets/images/mariposaEB_logo_no_background.png";
import {Product} from "../interfaces/interfaces";

export const useProductsByCategory = (categoryName: string) => {
    const [collections, setCollections] = useState<Record<string, any>>({});
    const [loading, setLoading] = useState(false);

    const fetchProducts = useCallback(() => {
        if (Object.keys(collections).length > 0) return;
        setLoading(true);
        getProducts()
            .then((products: any[]) => {
                const filtered = products.filter(p => p.category?.name === categoryName && p.active);
                const grouped = filtered.reduce((acc: Record<string, any>, product: Product) => {

                    const collection = product.collection
                    const collectionCoverImage = collection?.imageUrl ? collection.imageUrl : null;
                    const collectionName = collection?.name || 'Sans collection';
                    if (!acc[collectionName]) acc[collectionName] = {
                        cover_image: collectionCoverImage,
                        name: collectionName,
                        products: []
                    };
                    acc[collectionName].products.push({
                        id: product.id,
                        imageUrl: product.imageUrl ? `${API_URL}${product.imageUrl}` : logo,
                        name: product.name,
                        sold: product.sold,
                        price: `${product.price}`,
                        collection: product.collection,
                    });
                    return acc;
                }, {});
                setCollections(grouped);
            })
            .catch((e: any) => {
                console.error(e);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [categoryName]);

    return {collections, loading, fetchProducts};
};
